export const USER_NAME_ALREADY_EXISTS_VALIDATION_KEY =
  "validation:user-name-already-exists";

export const isUserNameDuplicateError = (message) => {
  if (typeof message !== "string") {
    return false;
  }

  const normalizedMessage = message.toLowerCase().replace(/[\s._-]/g, "");
  const isUserNameField =
    normalizedMessage.includes("username") ||
    normalizedMessage.includes("accountname");

  return (
    isUserNameField &&
    (normalizedMessage.includes("alreadyexists") ||
      normalizedMessage.includes("alreadyinuse"))
  );
};

export const findUserNameDuplicateError = (messageOrMessages) => {
  const messages = Array.isArray(messageOrMessages)
    ? messageOrMessages
    : [messageOrMessages];

  return messages.find(isUserNameDuplicateError);
};
